import mitt, { Emitter, EventType } from "mitt";
const mitter: Emitter<Record<EventType, unknown>> = mitt();
export default mitter;
